import { buildMakeUseAxios } from "@api";
import { useCallback } from "react";

const axios = buildMakeUseAxios(`${import.meta.env.VITE_WORKFLOW_SERVICE_URL}`);

export const useGetAPMs = () => {
  const [state, execute, cancel] = axios(
    {
      url: "/applys/process",
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    (filters?: any) => {
      return execute({
        url: "/applys/process",
        params: filters,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

export const useGetAPM = () => {
  const [state, execute, cancel] = axios(
    {
      url: "/applys/process",
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (id, filters) => {
      return execute({
        url: `/applys/process/${id}`,
        params: filters,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
